// Hero for a case study page. HeroContainer stays the home page's hero (flag,
// rotated location, per-letter animation); this one carries a project instead.
export default function ProjectHero(props: { hero: CaseStudyHeroT }) {
  const { title, eyebrow, description, image_Url, imageAlt = "", cta } = props.hero;

  return (
    <header className="case-hero">
      {image_Url ? <img className="case-hero-image" src={image_Url} alt={imageAlt} /> : null}
      <div className="case-hero-content">
        {eyebrow ? <p className="case-hero-eyebrow">{eyebrow}</p> : null}
        <h1 className="case-hero-title">{title}</h1>
        {description ? <p className="case-hero-description">{description}</p> : null}
        {cta && cta.url && cta.label ? (
          <a
            className="case-hero-cta"
            href={cta.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {cta.label}
          </a>
        ) : null}
      </div>
    </header>
  );
}
